<template>
    <div class="bg-pohvBlue rounded-md h-10 p-1.5 hover:opacity-90 cursor-pointer text-white" :class="[mode != 'text' && 'w-10', css]">
        <ArrowLongLeftIcon v-if="mode == 'arrowLeft'" />
        <ArrowLongRightIcon v-else-if="mode == 'arrowRight'" />
        <div v-else>{{ text }}</div>
    </div>
</template>

<script lang="ts" setup>
import { ArrowLongLeftIcon } from '@heroicons/vue/24/outline'
import { ArrowLongRightIcon } from '@heroicons/vue/24/outline'

defineProps<{
  text?: string
  css?: string
  mode: 'arrowLeft' | 'arrowRight' | 'text'
}>()

</script>